import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { of, Observable, ReplaySubject } from 'rxjs';
import { switchMap, take, map } from 'rxjs/operators';
import {
  UserProfile
} from '../profiles/profile.model';
import { Organization } from '../organizations/organization.model';

@Injectable({
  providedIn: 'root'
})
export class AuthUserService {

  private profile$: ReplaySubject<UserProfile> = new ReplaySubject(1);
  private organization$: ReplaySubject<Organization> = new ReplaySubject(1);

  constructor(
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
  ) {
    this.afAuth.auth.useDeviceLanguage();
    console.log('AuthUserService constructor');

    this.afAuth.user.pipe(
      take(1),
      map(authUser => {
        console.log('afAuth.user: ', authUser);
      })
    );

    this.afAuth.authState.pipe(
      switchMap( authUser => {
        if (authUser) {
          console.log('afAuth.authState: ', authUser);
          return this.afs.doc<any>(`profiles/${authUser.uid}`).valueChanges().pipe(
            switchMap( doc => {
              return of({ id: authUser.uid, ...doc });
            })
          );
        } else {
          return of(null);
        }
      })
    ).subscribe( profile => {
      console.log('currentProfile updated: ', profile);
      this.profile$.next(profile);
    });

    this.currentProfile$.pipe(
      switchMap( profile => {
        if (profile) {
          return this.afs.doc<any>(`organizations/${profile.organizationId}`).valueChanges().pipe(
            switchMap( doc => {
              return of({ id: profile.organizationId, ...doc });
            })
          );
        } else {
          return of(null);
        }
      })
    ).subscribe( organization => {
      this.organization$.next(organization);
    });
  }

  get currentProfile$(): Observable<UserProfile> {
    return this.profile$.asObservable();
  }

  get currentOrganization$(): Observable<Organization> {
    return this.organization$.asObservable();
  }
}
